import useBreakpoint from "../../hooks/useBreakpoint";
import { theme } from "../../theme/theme";
import Box from "../Box/Box";
import Button from "../Button/Button";
import { useState } from "react";

type Props = {
  isVideoZoomIn: boolean;
  isVideoOpen: boolean;
  handleZoomIn: () => void;
  handleClose: () => void;
  videoUrl: string;
};

const Video = ({
  isVideoOpen = false,
  videoUrl,
  isVideoZoomIn,
  handleClose,
  handleZoomIn,
}: Props) => {

  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const {isMobile, isTablet } = useBreakpoint();

  return !isVideoOpen ? (
    <></>
  ) : (
    <Box
      display="flex"
      style={{
        position: isVideoZoomIn ? 'fixed' : 'absolute',
        top: isVideoZoomIn || isMobile ? "50%" : undefined,
        left: isVideoZoomIn || isMobile ? "50%" : undefined,
        transform: isVideoZoomIn || isMobile ? "translate(-50%, -50%)" : undefined,
        width: isVideoZoomIn || isMobile ? "100vw" : 460,
        height: isVideoZoomIn || isMobile ? '100vh' : 260,
        padding:  isVideoZoomIn ? 0 : isMobile ? 20: undefined,
        backgroundColor: isVideoZoomIn || isMobile ? theme.colors.background : undefined,
        transition: 'width 0.5s ease-out',
        zIndex: 9999,
      }}
    >
        <Button
          style={{
            position: "absolute",
            top:isMobile? 30: 0,
            right: isMobile? 30: 0,
            zIndex: 1,
          }}
          label=""
          type="close"
          onClick={handleClose!}
        />
        <video
          loop
          autoPlay
          src={videoUrl}
          // height={isVideoZoomIn ? "100vh": undefined}
          onLoadedData={() => setIsVideoLoaded(true)}
          style={{
            width: "100%",
            height: isVideoZoomIn ? '100vh': undefined
          }}
        />
        <Button
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            zIndex: 1,
            display: isVideoZoomIn || isMobile ? "none" : "flex",
          }}
          label=""
          type="zoomIn"
          onClick={handleZoomIn!}
        />
    </Box>
  );
};

export default Video;
